import React, { useState } from 'react'
import { Button, Box, Backdrop } from '@mui/material'
import AppLoader from '../../../components/AppLoader/AppLoader';
import { Link, useNavigate } from 'react-router-dom';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useEffect } from 'react';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import 'react-toastify/dist/ReactToastify.css';
import './SupportCenterManagementTable.scss';
import '../OrganizationManagement.scss';
import '../OrgEntityDetailsDialog.scss';
import { tableStyle } from '../../../style/common';
import { cfpBaseUrl } from '../../../network/urls';
import CheckPermissions from '../../../authorization/authorization';
import AdminCompanySelect from '../../../components/AdminCompanySelect/AdminCompanySelect';
import BasicTable from '../../../components/basicTable/basicTable';
import useAdminOrgCompanyFilter from '../hooks/useAdminOrgCompanyFilter';
import { useSelector } from 'react-redux';
import SearchIcon from '@mui/icons-material/Search';
import { permissionsVariables } from '../../../services/Functions';

const displayValue = (value) => {
    if (value === null || value === undefined || value === '') return '-';
    return String(value);
};

const isCfcActive = (status) => {
    const normalized = String(status || '').toLowerCase();
    return normalized === '0' || normalized === 'active';
};

const DetailField = ({ label, value, wide = false }) => {
    const text = displayValue(value);
    return (
        <div className={`org-details-dialog__field${wide ? ' org-details-dialog__field--wide' : ''}`}>
            <span className="org-details-dialog__label">{label}</span>
            <p className={`org-details-dialog__value${text === '-' ? ' org-details-dialog__value--muted' : ''}`}>
                {text}
            </p>
        </div>
    );
};

const DetailSection = ({ title, children }) => (
    <section className="org-details-dialog__section">
        <div className="org-details-dialog__section-header">
            <span className="org-details-dialog__section-accent" />
            <h4>{title}</h4>
        </div>
        <div className="org-details-dialog__grid">{children}</div>
    </section>
);

export default function SupporCenterManagementTable() {
    const [NewcscToDataGrid, setNewcscToDataGrid] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [open2, setopen2] = useState(false);
    const [dltcfc, setdltcfc] = useState()
    const [dialogRowData, setDialogRowData] = React.useState({});
    const [tableCFC, setTableCFC] = useState([]) 
    const [viewBackdrop, setViewBackdrop] = useState(true);
    const [tableDataLoaded, setTableDataLoaded] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
     const [searchQuery, setSearchQuery] = useState("");
    const Navigate = useNavigate();
    const { token, code: userOfficeCode, permissions } = useSelector((state) => state.auth)
    const {
        isAdminUser,
        selectedCompanyCode,
        handleChangeCompany,
        getCfcApiCompanyCode,
    } = useAdminOrgCompanyFilter();

    useEffect(() => { 
        const AllCFCSAPI = async () => {
            setViewBackdrop(true);
            setTableDataLoaded(false);
            try {
                if (CheckPermissions(permissions, permissionsVariables.organizationManagement, "CSC Management")) {
                    const companyCode = getCfcApiCompanyCode();
                    if (companyCode === null) {
                        setTableCFC([]);
                        setTableDataLoaded(true);
                        return;
                    }

                    var formdata = new FormData();
                    formdata.append("companyCode", companyCode);
                    const myHeaders = new Headers();
                    myHeaders.append("Authorization", token);
                    var requestOptions = {
                        method: 'POST',
                        body: formdata,
                        headers: myHeaders,
                        redirect: 'follow',
                    };
                    await fetch(cfpBaseUrl + "customerFaciliationPortal/getAllCFCs", requestOptions)
                        .then(response => response.json())
                        .then(result => {
                            if (result.status === '200') {
                                const filteredData = result.data;
                                setTableCFC(filteredData);

                            } else {
                                setTableCFC([]);
                            }
                        })
                        .catch(() => {
                            setTableCFC([]);
                        });
                } else {
                    setTableCFC([]);
                }
            }
            catch (e) {
                setTableCFC([]);
            }
            setTableDataLoaded(true);
        }
        AllCFCSAPI()
    }, [selectedCompanyCode, userOfficeCode, isAdminUser])

    useEffect(() => {
        if (!tableDataLoaded) return;
        apiToDataGridConversion();
        setViewBackdrop(false);
    }, [tableCFC, tableDataLoaded]);

    const filterNCApp = (cfcid) => {
        const myArray = tableCFC
        let itemFound = myArray.find(item => item.cfcId === cfcid)

        return itemFound;
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleClose2 = () => {
        setopen2(false);
    };

    const tblColumns = [
        { field: "id", headerName: 'Code', headerAlign: 'left', align: 'left', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "name", headerName: 'Name', headerAlign: 'left', align: 'left', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "phone", headerName: 'Phone', headerAlign: 'left', align: 'left', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "email", headerName: 'Email', headerAlign: 'left', align: 'left', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "divisionCode", headerName: 'Division Code', headerAlign: 'left', align: 'left', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        {
            field: "address",
            headerName: 'Address',
            headerAlign: 'left',
            align: 'left',
            headerStyle: { ...tableStyle.headerStyle, width: '280px', minWidth: '240px', maxWidth: '360px' },
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: { ...tableStyle.rowCellStyle, width: '280px', minWidth: '240px', maxWidth: '360px' },
        },
        {
            field: "currentstatus",
            headerName: 'Status',
            headerAlign: 'left',
            align: 'left',
            headerStyle: { ...tableStyle.headerStyle, width: '80px', minWidth: '70px', maxWidth: '90px' },
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: { ...tableStyle.rowCellStyle, width: '80px', minWidth: '70px', maxWidth: '90px' },
        },
        {
            headerName: "Action",
            sortable: false,
            headerAlign: 'center',
            align: 'center',
            field: 'buttons',
            headerStyle: { ...tableStyle.headerStyle, width: '110px', minWidth: '100px', maxWidth: '120px' },
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: { ...tableStyle.rowCellStyle, width: '110px', minWidth: '100px', maxWidth: '120px' },
            renderCell: (params) => {
                const onViewCFC = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    setDialogRowData(params);
                    setOpen(true);
                };
                const onDeleteCFC = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    setopen2(true);
                    setdltcfc(params.id)
                }
                const onEditCFC = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    const cfcToEdit = filterNCApp(params.id);
                    Navigate('/support-center-management/UpdateCenterManagement', { state: { cfcToEdit } })
                }

                return (
                    <>
                        <Box>
                            {
                                CheckPermissions(permissions, 'Organization Management', 'CSC Management', 'Read') &&
                                <IconButton onClick={onViewCFC} aria-label="delete" size="small" sx={{ margin: 0.4, padding: 0 }}>
                                    <VisibilityIcon sx={{ color: 'skyblue' }} fontSize='inherit' />
                                </IconButton>
                            }
                            {
                                CheckPermissions(permissions, 'Organization Management', 'CSC Management', 'Update') &&
                                <IconButton aria-label="delete" size="small" sx={{ margin: 0.4, padding: 0 }} onClick={onEditCFC}>
                                    <EditIcon fontSize="inherit" sx={{ color: 'blue' }} />
                                </IconButton>
                            }
                            {
                                CheckPermissions(permissions, 'Organization Management', 'CSC Management', 'Delete') &&
                                <IconButton aria-label="delete" size="small" sx={{ margin: 0, padding: 0 }} onClick={onDeleteCFC}>
                                    <DeleteIcon fontSize="inherit" sx={{ color: 'red' }} />
                                </IconButton>
                            }
                        </Box>
                    </>
                )
            }
        },
    ]

    const apiToDataGridConversion = () => {
        const myArray = tableCFC
        const tempArray = []
        if (myArray) {
            //for(let i = 0; i <= myArray.length; i++){
            myArray.forEach((item) => {
                const dataGridObject = {
                    "id": item.cfcId,
                    "name": item.cfcName,
                    "phone": item.phoneNo,
                    "email": item.email,
                    "divisionCode": item.divisionCode,
                    "address": item.address,
                    "currentstatus": item.currentStatus,

                }
                tempArray.push(dataGridObject)
            })
        }

        setNewcscToDataGrid(tempArray);
        setFilteredData(tempArray);
    }

    const onDelete = async () => {
        setViewBackdrop(true)
        var formdata = new FormData();
        formdata.append("cfcId", dltcfc);

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "customerFaciliationPortal/deleteCFC", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === "200") {
                    let myArray = [...tableCFC]
                    let index = myArray.findIndex(obj => obj.cfcId === dltcfc);
                    myArray.splice(index, 1);
                    setTableCFC(myArray);
                    handleClose2();
                }
            })
            .catch(() => {});
        setViewBackdrop(false)
    }
 const handleSearch = (event) => {
  const value = event.target.value.toLowerCase();
  setSearchQuery(value);

  if (!value) {
    setFilteredData(NewcscToDataGrid);
    return;
  }

const filtered = NewcscToDataGrid.filter((row) =>
    row.id?.toString().toLowerCase().includes(value) ||
    row.name?.toString().toLowerCase().includes(value) ||
    row.phone?.toString().toLowerCase().includes(value) ||
    row.email?.toString().toLowerCase().includes(value) ||
    row.divisionCode?.toString().toLowerCase().includes(value) || // ✅ fixed
    row.address?.toString().toLowerCase().includes(value) ||
    row.currentstatus?.toString().toLowerCase().includes(value)
  );

  setFilteredData(filtered);
};
    return (
        <>
            <Box className='form-box org-management-list'>
                {/* <Box className='main-heading'>
                    <h2  >
                        Customer Facilitation Centers
                    </h2>
                    <Box className='btn2'>
                        <Link to="new-support-center">
                            <Button variant="contained" size='small' className='btnNewApplication' startIcon={<AddCircleIcon />} >Add Center</Button>
                        </Link>
                    </Box>
                </Box> */}
                <Box className="mgmt-page-header">
                    <div className="mgmt-page-header__leading">
                        <h3 className="page-title">Customer Facilitation Centers Management</h3>
                        {isAdminUser && (
                            <AdminCompanySelect
                                value={selectedCompanyCode}
                                onChange={handleChangeCompany}
                                minWidth={180}
                                includePitc={false}
                                restrictToEnabled={false}
                            />
                        )}
                    </div>
                    <div className="mgmt-table-search">
                        <span className="mgmt-table-search__badge" aria-hidden="true">
                            <SearchIcon className="mgmt-table-search__icon" />
                        </span>
                        <input
                            type="text"
                            className="mgmt-table-search__input"
                            value={searchQuery}
                            onChange={handleSearch}
                            placeholder="Search by Code, Name, Phone, Email or Address"
                            maxLength={20}
                            aria-label="Search facilitation centers"
                        />
                    </div>
                </Box>
                <Box className='application-table'>
                    <BasicTable
                        data={filteredData}
                        columns={tblColumns}
                        sx={tableStyle}
                        rowHeight={37.5}
                        pageSize={18}
                        rowsPerPageOptions={[18, 30, 60]}
                        rowsPageOption={false}
                        getRowStyle={(params) => {
                            return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyle.evenRow : tableStyle.oddRow
                        }}
                    />
                </Box>
            </Box>

            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth="md"
                className="alert-popups org-details-dialog"
                aria-labelledby="cfc-details-dialog-title"
            >
                <DialogTitle
                    id="cfc-details-dialog-title"
                    component="div"
                    className="dialog-title"
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                >
                    <span className="org-details-dialog__title-text">Customer Facilitation Center Details</span>
                    <IconButton
                        onClick={handleClose}
                        size="small"
                        aria-label="Close CFC details"
                        className="org-details-dialog__close"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent className="dialog-content">
                    <div className="org-details-dialog__body">
                        <div className="org-details-dialog__hero">
                            <div className="org-details-dialog__logo-wrap">
                                <div className="org-details-dialog__avatar" aria-hidden="true">
                                    {(dialogRowData.name || 'C').toString().charAt(0).toUpperCase()}
                                </div>
                            </div>
                            <div className="org-details-dialog__hero-meta">
                                <h2 className="org-details-dialog__name">
                                    {displayValue(dialogRowData.name)}
                                </h2>
                                <p className="org-details-dialog__code">
                                    Office Code: <strong>{displayValue(dialogRowData.id)}</strong>
                                </p>
                                <span
                                    className={`org-details-dialog__status org-details-dialog__status--${
                                        isCfcActive(dialogRowData.currentstatus) ? 'active' : 'inactive'
                                    }`}
                                >
                                    {isCfcActive(dialogRowData.currentstatus) ? 'Active' : 'Inactive'}
                                </span>
                            </div>
                        </div>

                        <DetailSection title="General Information">
                            <DetailField label="Division Code" value={dialogRowData.divisionCode} />
                            <DetailField label="Office Code" value={dialogRowData.id} />
                            <DetailField label="Email" value={dialogRowData.email} />
                            <DetailField label="Phone No." value={dialogRowData.phone} />
                            <DetailField label="Address" value={dialogRowData.address} wide />
                        </DetailSection>
                    </div>
                </DialogContent>
            </Dialog>

            <Dialog
                open={open2}
                onClose={handleClose2}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {" Are you sure to delete this record"}
                </DialogTitle>
                <DialogActions>
                    <Button onClick={handleClose2}>Cancel</Button>
                    <Button onClick={onDelete} autoFocus>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <AppLoader />
            </Backdrop >
        </>
    )
}
